var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-list',{attrs:{"apiUrls":_vm.apiUrls,"formCols":_vm.formCols,"updateCols":_vm.updateCols,"tableCols":_vm.tableCols}})}
var staticRenderFns = []

export { render, staticRenderFns }